import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { provideDfUiAnchorScroll } from './anchor-scroll/anchor-scroll.providers';
import { NUi } from './df-ui.config';

export const providers = (config?: DeepPartial<NUi.IModuleOptions>) => [
    {
        provide: NUi.OPTIONS,
        useFactory: () => defaultsDeep(config, NUi.DEFAULT_OPTIONS)
    }
];

export function provideDfUi(config?: DeepPartial<NUi.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([provideDfUiAnchorScroll(), ...providers(config)]);
}
